import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Login from "../views/Login.vue";
import Home from "../views/Home.vue";



// clases
import Clases from "../views/Clases/Clases";

// Test
import Test from "../views/TestView/Test";

//change password
import ChangePassword from "../views/ChangePassword/ChangePassword.vue"



import ResetPassword from "../views/ResetPassword";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (store.getters.token == "") {
    next();
    return;
  } else {
    next({ name: "Home" });
  }
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.token != "") {
    next();
  } else {
    next({ name: "Login" });
  }
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: ifAuthenticated
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: ifNotAuthenticated
  },

   //Change password
   {
    path:"/change-password",
    name:"ChangePassword",
    component:ChangePassword,
    beforeEnter: ifAuthenticated
  },

  //clases
  {
    path:"/clases",
    name:"Clases",
    component:Clases,
    beforeEnter: ifAuthenticated
  },

  //Test
  {
    path:"/Evaluaciones",
    name:"Evaluaciones",
    component:Test,
    beforeEnter: ifAuthenticated
  },

  {
    path: "/reset-password/:token",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
